(function () {
  'use strict';

  angular.module('app').component('providerContactList', providerContactList());

  function providerContactList() {
    return {
      bindings: {
        provider: '=',
        providerContacts: '=',
      },
      controller: ProviderContactListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/providers/provider-contacts/provider-contact-list/provider-contact-list.component.html',
    };
  }

  ProviderContactListComponent.$inject = [
    'UtilService',
    'AbilityService',
    'ProviderContactService',
  ];

  function ProviderContactListComponent(UtilService, AbilityService, ProviderContactService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_provider_accountadmin'),
      canShow: AbilityService.can('show_provider_accountadmin'),
      canUpdate: AbilityService.can('update_provider_accountadmin'),
      canDestroy: AbilityService.can('destroy_provider_accountadmin'),
    };

    var fastCreation = false;

    // Methods
    vm.addProviderContact = addProviderContact;
    vm.showProviderContact = showProviderContact;
    vm.changeProviderContactStatus = changeProviderContactStatus;
    vm.changeProviderContactDefault = changeProviderContactDefault;
    vm.deleteProviderContact = deleteProviderContact;

    vm.$onInit = function () {
      checkDefaultProviderContact();
    };

    function addProviderContact() {
      if (!vm.permissions.canCreate) {
        return;
      }

      var successCallback = function (selectedItem) {
        vm.providerContacts.push(selectedItem);
        vm.UtilService.itemListChanged(selectedItem.id);

        checkDefaultProviderContact();
      };

      ProviderContactService.openProviderContactModal(
        {},
        vm.provider,
        'create',
        fastCreation,
        successCallback
      );
    }

    function showProviderContact(providerContact, mode) {
      if (!vm.permissions.canShow) {
        return;
      }

      var successCallback = function (response) {
        // vm.onProviderContactSaved();
      };

      ProviderContactService.openProviderContactModal(
        providerContact,
        vm.provider,
        mode,
        fastCreation,
        successCallback
      );
    }

    function changeProviderContactStatus(providerContact) {
      if (!vm.permissions.canUpdate || providerContact.is_default) {
        return;
      }

      ProviderContactService.changeProviderContactStatus(providerContact, vm.provider.id);
    }

    function changeProviderContactDefault(providerContact) {
      if (!vm.permissions.canUpdate || providerContact.is_default) {
        return;
      }

      var successCallback = function () {
        vm.providerContacts.forEach(function (contact) {
          contact.is_default = false;

          if (contact.id === providerContact.id) {
            contact.is_default = true;
          }
        });

        checkDefaultProviderContact();
      };

      ProviderContactService.changeProviderContactDefault(providerContact, successCallback);
    }

    function deleteProviderContact(providerContact, index) {
      if (!vm.permissions.canDestroy || providerContact.is_default) {
        return;
      }

      var successCallback = function (index) {
        vm.providerContacts.splice(index, 1);
      };

      ProviderContactService.deleteProviderContact(
        providerContact,
        vm.provider.id,
        successCallback,
        index
      );
    }

    function checkDefaultProviderContact() {
      for (var i = 0; i < vm.providerContacts.length; i++) {
        if (vm.providerContacts[i].is_default) {
          vm.errorDefaultProviderContact = false;
          return;
        }
      }

      vm.errorDefaultProviderContact = true;
    }
  }
})();
